"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Primary UI component for user interaction
 */ "default", {
    enumerable: true,
    get: function() {
        return LoungeDetails;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _core = require("@mantine/core");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function LoungeDetails(param) {
    var infos = param.infos;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Flex, {
            direction: {
                base: "column",
                lg: "row"
            },
            style: {
                gap: "1.5rem"
            },
            children: infos.map(function(info, i) {
                return /*#__PURE__*/ (0, _jsxruntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
                            fw: 600,
                            children: info.header
                        }),
                        /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
                            children: info.description
                        })
                    ]
                }, i);
            })
        })
    });
}
